module.exports = __webpack_public_path__ + "assets/images/project/constituencies/marsiling-yew-tee-grc.jpg?v=681675c3";